import { Component, OnInit, Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Resolve } from '@angular/router';
import { getTitle, getDescription } from './lib/helpers';
import { RestComponent } from './lib/RestComponent';
import { Order, OrderService } from './cart/order.service';
import { BreadCrumbsService } from './breadcrumbs.service';
import { UserService } from './user.service';

const defaultNavParams = {
  iNumPage: 0,
  nPageSize: 20
};

@Component({
  selector: 'personal-orders',
  templateUrl: '../templates/personal-orders.component.html',
  styleUrls: ['../styles/components/personal-orders.component.less']
})
export class PersonalOrdersComponent extends RestComponent implements OnInit {
  items: Order[] = [];
  navParams: any = Object.assign({}, defaultNavParams);
  isLastPage: boolean = false;

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private breadCrumbsService: BreadCrumbsService,
    private userService: UserService
  ) {
    super();

    this.titleService.setTitle(getTitle('Заказы'));
    this.metaService.updateTag({name: 'description', content: getDescription('Заказы')});
    this.breadCrumbsService.create([{
      name: 'Заказы',
      color: 'general-primary'
    }]);
  }

  public ngOnInit() {
    this.route.data.subscribe((data: {orders: Order[]}) => {
      this.items = data.orders;

      if (!this.items.length || this.items.length < this.navParams.nPageSize) {
        this.isLastPage = true;
      }
    });
  }

  public async loadMore() {
    this.navParams.iNumPage++;
    this.loadingState = true;
    try {
      const items = await this.orderService.get({
        filter: {USER_ID: this.userService.user.ID},
        limit: this.navParams.nPageSize,
        offset: this.navParams.nPageSize * this.navParams.iNumPage
      });
      this.items = this.items.concat(items);

      // Check is last page reached
      if (!items.length || items.length < this.navParams.nPageSize) {
        this.isLastPage = true;
      }

      this.loadingState = false;
      return this.items;
    } catch (e) {
      this.error = true;
      this.errorMessage = e.message;
      this.loadingState = false;
    }
  }
}

@Injectable()
export class PersonalOrdersResolver implements Resolve<Order[]> {
  navParams: any = defaultNavParams;

  constructor(
    private orderService: OrderService,
    private userService: UserService
  ) {}

  public resolve(): Promise<Order[]> {
    return this.orderService.get({
      limit: this.navParams.nPageSize,
      filter: {USER_ID: this.userService.user.ID}
    }).catch(() => []);
  }
}
